<template>
    <div>
        <a-form>
            <a-result title="审核中" :is-success="true" sub-title="等待审核" style="max-width: 560px; margin: 40px auto 0;">
                <div class="information">
                </div>
                <template #extra>
                    <!--                    <a-button style="margin-left: 8px" @click="toOrderList">查看</a-button>-->
                </template>
            </a-result>
        </a-form>
    </div>
</template>

<script>
    export default {
        name: 'ModifyStep3',
        created() {
            this.skip();
        },
        destroyed() {
            clearTimeout(this.timer);
        },
        data () {
            return {
                loading: false,
                timer:''
            }
        },
        methods: {
            finish () {
                this.$emit('finish')
            },
            toOrderList () {
                this.$router.push('/enterprise/Authing')
            },
            skip() {
                let that = this
                this.timer = setTimeout(function () {
                    that.$router.push({path:'/index'})
                },1000)
            }
        }
    }
</script>
<style lang="less" scoped>
    .information {
        line-height: 22px;

        .ant-row:not(:last-child) {
            margin-bottom: 24px;
        }
    }
    .money {
        font-family: "Helvetica Neue",sans-serif;
        font-weight: 500;
        font-size: 20px;
        line-height: 14px;
    }
</style>
